import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const usageTime = useStore((state) => state.usageTime);
  const setUsageTime = useStore((state) => state.setUsageTime);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.usageTime.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={usageTime}
          onChange={(value) => {
            setUsageTime(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'usage-time',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"5 min/day (rarely)"}>
            <span>⏱️</span> {t('onboarding.usageTime.options.rarely')}
          </Option>
          <Option value={"10 min/day (regularly)"}>
            <span>🕒</span> {t('onboarding.usageTime.options.regularly')}
          </Option>
          <Option value={"15 min/day (seriously)"}>
            <span>🧠</span> {t('onboarding.usageTime.options.seriously')}
          </Option>
          <Option value={"30 min/day (intensively)"}>
            <span>🔥</span> {t('onboarding.usageTime.options.intensively')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
